import { useStore } from '../store';
import { PermissionSlug } from '../constants/featureFlags';

/**
 * Whether this user may change a task's date from the Hotbox list.
 *
 * Separate from `hotbox:access`, and only this slug counts — the route gates on
 * `hotbox:reschedule` alone, so widening it here would show an enabled picker
 * to users whose every save is rejected.
 */
export function useCanRescheduleFromHotbox(): boolean {
  // Call inside the selector so a grant/revoke re-renders. Selecting
  // `state.hasPermission` alone is a stable function reference and stays stale.
  return useStore(state =>
    state.hasPermission(PermissionSlug.HOTBOX_RESCHEDULE)
  );
}
